// extracted by mini-css-extract-plugin
export default {"deviceButton":"ToggleChatButton_deviceButton__Z1Evk","icon":"ToggleChatButton_icon__4IQ81","chatIconBadge":"ToggleChatButton_chatIconBadge__cyMdx"};